<template>
  <div class="dashboard-va-main">
    <div class="dashboard-va-top">
      <div
        class="dashboard-va-top__box"
      >
        <p>Total Vendor Aktif</p>
        <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_active ? $store.state.vaStore.total_vendor_active : 0}}</p>
        <p v-else>memuat...</p>
      </div>
      <div
        class="dashboard-va-top__box"
      >
        <p>Total Vendor Jasa Inti</p>
        <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_jasa_inti ? $store.state.vaStore.total_vendor_jasa_inti : 0}}</p>
        <p v-else>memuat...</p>
      </div>
      <div
        class="dashboard-va-top__box"
      >
        <p>Total Vendor Non Jasa Inti</p>
        <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_non_inti ? $store.state.vaStore.total_vendor_non_inti : 0}}</p>
        <p v-else>memuat...</p>
      </div>
      <div
        class="dashboard-va-top__box"
      >
        <p>Total Vendor Nasional</p>
        <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_national ? $store.state.vaStore.total_vendor_national : 0}}</p>
        <p v-else>memuat...</p>
      </div>
      <div
        class="dashboard-va-top__box"
      >
        <p>Total Vendor International</p>
        <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_inter ? $store.state.vaStore.total_vendor_inter : 0}}</p>
        <p v-else>memuat...</p>
      </div>
    </div>
    <div class="dashboard-va-bottom">
      <div class="va-bottom-left">
        <total-vendor-per-region />
        <total-spend-vendor-region />
      </div>
      <div class="va-bottom-right">
        <div class="br-left">
          <total-spend-category-number />
          <total-spend-category-department />
          <!-- <div class="brl-bottom">ini bottom</div> -->
        </div>
        <div class="br-right">
          <PraqualifikasiKplhVendor/>
          <PraqualifikasiK3lVendor />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import PraqualifikasiKplhVendor from './bottom-right/praqualifikasi-kplh-vendor.vue';
import PraqualifikasiK3lVendor from './bottom-right/praqualifikasi-k3l-vendor.vue';
import { api } from '@/services/config.js'

export default {
  components: {
    TotalVendorPerRegion: () => import("@/components/dashboard/main-va/bottom-left/total-vendor-per-region.vue"),
    TotalSpendVendorRegion: () => import("@/components/dashboard/main-va/bottom-left/total-spend-vendor-region.vue"),
    TotalSpendCategoryNumber: () => import("@/components/dashboard/main-va/bottom-right/total-spend-category-number.vue"),
    TotalSpendCategoryDepartment: () => import("@/components/dashboard/main-va/bottom-right/total-spend-category-department-incharge.vue"),
    PraqualifikasiKplhVendor,
    PraqualifikasiK3lVendor,
  },
  data() {
    return {
      header: [
        {
          desc: 'Total Vendor Aktif',
          value: 500,
        },
        {
          desc: 'Total Vendor Jasa Inti',
          value: 600,
        },
        {
          desc: 'Total Vendor Non Jasa Inti',
          value: 1000,
        },
        {
          desc: 'Total Vendor Nasional',
          value: 800,
        },
        {
          desc: 'Total Vendor International',
          value: 200,
        },
      ],
    }
  },
  
}
</script>
<style scoped>
.doughnat-container {
  width: 33%;
  height: 100%;
  position: relative;
}
.region-list {
  width: 60%;
  height: 100%;
  overflow-y: auto;
}
</style>
